export default {
  configure: {
    "B": {
      PID: "B",
      id: "",
      name: "",
      logo: "",
      domainName: "", // 商户端
      OSSDomain: "",
      mobUrlUser: "",
      mobUrlOrder: [
        {
          name: "点击下载模板（对私）",
          msg: "（请按照模板填写人员费用数据）",
          url: ""
        },
        {
          name: "点击下载模板（对公）",
          msg: "（请按照模板填写对公费用数据）",
          url: ""
        }
      ],
      newOrderTips: [
        "<h5>提示：</h5><p>1、上传表格条数不能超过2000条；</p><p>2、单人单次支付金额需小于50,000元，金额超出系统自动拆分；</p><p>3、单人单月支付金额不超过95,000元；</p><p>4、预计2小时内到账，具体支付时间以银行通知为准；</p><p>5、由于银行对公转账的相关限制，费用支付在工作日内：</p><p>周一至周五 09:30~15:00之间进行，超过该时间顺延到第二个工作日办理，如需按时支付请提前做好相关工作准备。</p>",
        "<h5>提示：</h5><p>1、上传表格条数不能超过2000条；</p><p>2、对公单笔支付金额需小于200000元；</p><p>3、对公单日支付金额不超过300000元；</p><p>4、预计2小时内到账，具体支付时间以银行通知为准；</p><p>5、由于银行对公转账的相关限制，费用支付请在工作日内：</p><p>周一至周五 09:30~15:00 之间进行，超过该时间顺延到第二个工作日办理，如需按时支付请提前做好相关工作准备。</p>"
      ],
      newOrderTipsSingle: [
        "<h5>提示：</h5><p>1、单人单次支付金额需小于50,000元；</p><p>2、单人单月支付金额不超过95,000元；</p><p>3、预计2小时内到账，具体支付时间以银行通知为准；</p><p>4、由于银行对公转账的相关限制，费用支付请在工作日内：</p><p>周一至周五 09:30~15:00之间进行，超过该时间顺延到第二个工作日办理，如需按时支付请提前做好相关工作准备。</p><p style='color:#f00'>5、若需要修改单笔发放信息，请删除输入框内全部内容并重新输入。</p>",
        "<h5>提示：</h5><p>1、对公单笔支付金额需小于50,000元；</p><p>2、对公单日支付金额不超过300000元；</p><p>3、预计2小时内到账，具体支付时间以银行通知为准；</p><p>4、由于银行对公转账的相关限制，费用支付请在工作日内：</p><p>周一至周五 09:30~15:00之间进行，超过该时间顺延到第二个工作日办理，如需按时支付请提前做好相关工作准备。</p><p style='color:#f00'>5、若需要修改单笔发放信息，请删除输入框内全部内容并重新输入。</p>"
      ],
      QrUrl: "https://devb.sktax.cn/home.html", // 测试
      // QrUrl: "https://xcx.towardstarry.com/home.html", // 正式
      content: "© 2022 望宿科技（北京）有限公司",
      recordNo: "",
      style: "@/assets/styles/tianrun",
      image: "@/assets/images/tianrun",
      logoImg: "assets/images/logo_wx.png",
      loginPage: '/#/login-wx',
      accountTypeInfoArr: [
        {accountId: "", label: "系统账户", value: "2"},
        {accountId: "", label: "支付宝账户", value: "5"},
        {accountId: "", label: "汇付宝账户", value: "9"},
        {accountId: "", label: "民生账户", value: "10"},
        {accountId: "", label: "津盛账户", value: "11"},
        {accountId: "", label: "中新能账户", value: "12"}
      ],
      payTypeInfoArr: [
        {accountId: "", label: "线下支付", value: "3"},
        {accountId: "", label: "支付宝支付", value: "5"},
        {accountId: "", label: "汇付宝支付", value: "9"},
        {accountId: "", label: "微信支付", value: "6"},
        {accountId: "", label: "民生银行支付", value: "10"},
        {accountId: "", label: "津盛支付", value: "11"},
        {accountId: "", label: "中新能支付", value: "12"}
      ],
      orderPayTypeArr: [
        [
          { label: "银行卡", value: 1 },
          { label: "支付宝", value: 2 },
          { label: "微信", value: 3 }
        ],
        [
          { label: "对公账户", value: 5 },
          { label: "企业支付宝", value: 6 }
        ]
      ],
      auditFlagArr: [
        { accountId: "", label: "待充值", value: "0" },
        { accountId: "", label: "审核中", value: "1" },
        { accountId: "", label: "支付中", value: "2" },
        { accountId: "", label: "线下支付", value: "3" },
        { accountId: "", label: "支付完成", value: "4" },
        { accountId: "", label: "已驳回", value: "5" },
        { accountId: "", label: "取消支付", value: "6" },
        { accountId: "", label: "支付失败", value: "8" },
        { accountId: "", label: "API支付中", value: "9" },
        { accountId: "", label: "API支付完成", value: "10" },
      ],
      payStatusSearchArr: [
        { accountId: "", label: "待支付", value: "0" },
        { accountId: "", label: "支付中", value: "1" },
        { accountId: "", label: "支付成功", value: "2" },
        { accountId: "", label: "支付失败", value: "3" },
        { accountId: "", label: "退汇成功", value: "5" },
      ],
      payStatusArr: [
        { accountId: "", label: "待支付", value: "0" },
        { accountId: "", label: "支付中", value: "1" },
        { accountId: "", label: "支付成功", value: "2" },
        { accountId: "", label: "支付失败", value: "3" },
        { accountId: "", label: "退汇成功", value: "5" },
        { accountId: "", label: "未实名", value: "9" },
      ],
      taskStatusArr: [
        { accountId: "", label: "招标中", value: "0" },
        { accountId: "", label: "已开工", value: "1" },
        { accountId: "", label: "已完工", value: "2" },
      ],
      operateValueArr: [
        { accountId: "", label: "待审核", value: "0" },
        { accountId: "", label: "已通过", value: "1" },
        { accountId: "", label: "已驳回", value: "2" },
        // { accountId: "", label: "已停用", value: "3" },  //删除已停用状态  by bobby 2024-08-01
      ],
      orderTypeArray: [
        { accountId: "", label: "批量支付", value: 1 },
        { accountId: "", label: "API支付", value: 2 },
        { accountId: "", label: "单笔支付", value: 3 },
        { accountId: "", label: "快捷支付", value: 4 },
      ],
      signingStatusArray: [
        { accountId: "", label: "未认证", value: "EMPTY" },
        { accountId: "", label: "已认证", value: "AUTHED" },
        { accountId: "", label: "已注销", value: "DELETED" },
      ],
      signingStatusArr: [
        { accountId: "", label: "--", value: "EMPTY" },
        { accountId: "", label: "未认证", value: "UN_AUTH" },
        { accountId: "", label: "待审核", value: "AUTHING" },
        { accountId: "", label: "已认证", value: "AUTHED" },
        { accountId: "", label: "已签署", value: "SIGNED" },
        { accountId: "", label: "已驳回", value: "NOT_AUTH" },
        { accountId: "", label: "已注销", value: "DELETED" },
      ],
      checkedArray: [
        { accountId: "", label: "未关联", value: "1" },
        { accountId: "", label: "已关联", value: "2" },
      ],
      balanceSubjectArr: [
        { accountId: "", label: "支付", value: "0001" },
        { accountId: "", label: "服务费", value: "0002" },
        { accountId: "", label: "充值", value: "0003" },
        { accountId: "", label: "支付返还", value: "0006" },
        { accountId: "", label: "系统加款", value: "0007" },
        { accountId: "", label: "系统扣款", value: "0008" },
        { accountId: "", label: "支付宝加款", value: "0015" },
        { accountId: "", label: "支付宝扣款", value: "0016" },
        // { accountId: "", label: "退款申请", value: "0009" },
        // { accountId: "", label: "退款返还", value: "0010" },
        { accountId: "", label: "银行退汇", value: "0017" },
        { accountId: "", label: "对公手续费扣除", value: "0018" },
        { accountId: "", label: "对公手续费退还", value: "0019" },
        { accountId: "", label: "商户退款", value: "0025" },
        {accountId: "", label: "个税扣除", value: "0031"},
        {accountId: "", label: "退汇返还个税", value: "0032"},
        {accountId: "", label: "个税返还", value: "0033"},
        // { accountId: "", label: "商户退款失败/驳回", value: "0026" },
      ],
      refundStatusArr: [
        { accountId: "", label: "退款审核", value: "0" },
        { accountId: "", label: "退款中", value: "1" },
        { accountId: "", label: "退款完成", value: "2" },
        { accountId: "", label: "线下退款", value: "3" },
        { accountId: "", label: "已驳回", value: "4" },
        { accountId: "", label: "退款失败", value: "5" },
      ],
      requestTypeArr: [
        { accountId: "", label: "充值", value: "充值" },
        { accountId: "", label: "发放", value: "发放" },
        { accountId: "", label: "开票", value: "开票" },
        { accountId: "", label: "新增", value: "新增" },
        { accountId: "", label: "删除", value: "删除" },
        { accountId: "", label: "通知", value: "通知" },
        { accountId: "", label: "登录", value: "登录" },
        { accountId: "", label: "退款", value: "退款" },
        { accountId: "", label: "修改", value: "修改" },
        { accountId: "", label: "邀请", value: "邀请" },
      ],
      balanceSubArr: [
        { accountId: "", label: "发放费用", value: "0001" },
        { accountId: "", label: "服务费", value: "0002" },
        { accountId: "", label: "充值", value: "0003" },
        { accountId: "", label: "月结分润", value: "0004" },
        { accountId: "", label: "季结分润", value: "0005" },
        { accountId: "", label: "返还金额", value: "0006" },
        { accountId: "", label: "系统加款", value: "0007" },
        { accountId: "", label: "系统扣款", value: "0008" },
        { accountId: "", label: "支付宝加款", value: "0015" },
        { accountId: "", label: "支付宝扣款", value: "0016" },
        { accountId: "", label: "退款申请", value: "0009" },
        { accountId: "", label: "退款返还", value: "0010" },
        { accountId: "", label: "提现订单", value: "0011" },
        { accountId: "", label: "提现订单驳回", value: "0014" },
      ],
      billAuditFlagArr: [
        { accountId: "", label: "已提交", value: "0" },
        { accountId: "", label: "已开票", value: "1" },
        { accountId: "", label: "已驳回", value: "2" },
        // { accountId: "", label: "开票金额作废", value: "6" },
      ],
      taxTypeArr: [
        { accountId: "", label: "不扣税", value: "NONE" },
        { accountId: "", label: "税前", value: "BENEFICIARY" },
        { accountId: "", label: "税后", value: "MERCHANT" },
      ],
      exemptionSwitchArr:[
        { accountId: "", label: "免征", value: true },
        { accountId: "", label: "不免征", value: false },

      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/configure.js